
import CartoDbLayer from './cartoDbLayer';

export default class Map {

    constructor(node, options, vuexStore) {
        this.poligons = {};
        this.markers = {};
        this.cartoDbLayers = {};
        var mapTypeIds = [];
        for (var type in google.maps.MapTypeId) {
            mapTypeIds.push(google.maps.MapTypeId[type]);
        }
        mapTypeIds.push("SITIMAPA");

        var defaultOptions = {
            center: { lat: 4.2459816112069655, lng: -73.45040413379957 },
            zoom: 6,
            mapTypeControl: true,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
                mapTypeIds
            },
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
            },
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
            },
            fullscreenControl: false,
            styles: [
            ]
        };



        this.mapInstance = undefined;
        this.node = node;
        this.options = Object.assign({}, options, defaultOptions);
        this.onStreetviewChange = this.options.onStreetviewChange;
        this.onSendButtonClicked = this.options.onSendButtonClicked;
        this.create();
    }

    create() {
        var _node = document.getElementById(this.node);
        if (!_node)
            return;
        this.mapInstance = new google.maps.Map(_node, this.options);

        this.mapInstance.mapTypes.set(
            "SITIMAPA",
            new google.maps.ImageMapType({
                getTileUrl: function (coord, zoom) {
                    return (
                        "http://tiles.sitimapa.com/" +
                        zoom +
                        "/" +
                        coord.x +
                        "/" +
                        coord.y +
                        ".png"
                    );
                },
                tileSize: new google.maps.Size(256, 256),
                name: "Sitimapa",
                maxZoom: 18
            })
        );

        /**
         * Diasable Sitios de Interes
         */
        /*
                this.mapInstance.setOptions({
                    styles: {
                        featureType: 'poi.business',
                        stylers: [{ visibility: 'off' }]
                    }
                });
        
        */
        /**
         * Events
         */


        /**
         * 
         */
        this.createObjects();
        this.createLayers();
        this.setEvents();
    }

    createObjects() {
        this.mainMarker = new google.maps.Marker({
            draggable: true,
            icon: this.options.marker_icon
        });

        this.mainInfoWindow = new google.maps.InfoWindow({});

        this.userMarker = new google.maps.Marker({
            draggable: false,
            title: "Posición Actual"
        });
    }

    createLayers() {
        this.trafficLayer = new google.maps.TrafficLayer();
    }

    setEvents() {
        var self = this;
        self.mapInstance.addListener('click', function (e) {
            if (self.options.events.mapClick) {
                self.options.events.mapClick(e);
            }
        });

        this.mainMarker.addListener('click', (e) => {
            this.mainInfoWindow.setContent(this._createInfowinTemplate());
            this.mainInfoWindow.open(this.mapInstance, this.mainMarker);
        });

        this.mainMarker.addListener('dragend', (e) => {
            this.mainInfoWindow.close();
        });

        var thePanorama = self.mapInstance.getStreetView();
        google.maps.event.addListener(thePanorama, 'visible_changed', function () {
            setTimeout(() => {
                if (self.onStreetviewChange) {
                    self.onStreetviewChange(thePanorama.getVisible());
                }
            }, 500);
        });
    }

    showUserMarker(lat, lng, image){
        this.userMarker.setPosition({lat, lng});
        this.userMarker.setIcon(image);
        this.userMarker.setMap(this.mapInstance);
    }

    _createInfowinTemplate() {
        var position = this.mainMarker.getPosition();
        var cx = position.lng();
        var cy = position.lat();
        var btn = document.createElement("button");
        btn.setAttribute('value', "Enviar");
        btn.setAttribute('onclick', `window.onClickSendInfowin()`);
        btn.innerText = "Enviar";
        var button = btn.outerHTML;
        var html = `
            <div class='infowinDtv'>
                <table class='table-bordered'>
                    <tr>
                        <th>Cx</th>
                        <td>${cx}</td>
                    </tr>
                    <tr>
                        <th>Cy</th>
                        <td>${cy}</td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>
                            <button class="pure-button" onclick="window.onClickSendInfowin(${cy}, ${cx})">Enviar</button>
                        </td>
                    </tr>
                </table>
            </div>
        `;
        return html;
    }

    setCenter(lng, lat, zoom) {
        var position = { lat, lng };
        this.mapInstance.setCenter(position);
        if (zoom && zoom > 0) {
            this.mapInstance.setZoom(zoom);
        }
    }

    setCenterPostion(position) {
        this.mapInstance.setCenter(position);
    }

    setZoom(zoom) {
        this.mapInstance.setZoom(Number(zoom));
    }

    onTrafficLayer() {
        this.trafficLayer.setMap(this.mapInstance);
    }

    toggleTrafficLayer() {
        if (!this.trafficLayer.getMap()) {
            this.onTrafficLayer();
        } else {
            this.offTrafficLayer();
        }
    }

    offTrafficLayer() {
        this.trafficLayer.setMap(null);
    }

    addCircle(id, center, population, options) {
        if (this.poligons[id]) {
            this.poligons[id].setMap(null);
            delete this.poligons[id];
        }

        this.poligons[id] = new google.maps.Circle({
            center: center,
            radius: parseFloat(population), //Math.sqrt(citymap[city].population) * 100
            ...options
          });
        
        this.poligons[id].setMap(this.mapInstance);
        this.mapInstance.fitBounds(this.poligons[id].getBounds());
    }

    addPolygon(id, coords, options) {
        if (this.poligons[id]) {
            this.poligons[id].setMap(null);
        }
        options.paths = coords;
        this.poligons[id] = new google.maps.Polygon(options);
        this.poligons[id].setMap(this.mapInstance);
        if (options.pathTo) {
            var bounds = new google.maps.LatLngBounds();
            for (var coord in coords) {
                bounds.extend(coords[coord]); //new google.maps.LatLng(coord.lat, coord.lng));
            }
            this.mapInstance.fitBounds(bounds);
        }
    }

    createBounds() {
        return new google.maps.LatLngBounds();
    }

    fitBounds(bounds) {
        this.mapInstance.fitBounds(bounds);
    }

    addMarker(id, latLng, options) {
        if (this.markers[id]) {
            this.markers[id].setMap(null);
            delete this.markers[id];
        }

        this.markers[id] = new google.maps.Marker({
            draggable: false,
            icon: options.icon,
            title: options.title,
            position: latLng,
            map: this.mapInstance,
            ...options.markerOptions
        });

        if (options.infowin) {
            this.markers[id].infowin = options.infowin;
            var self = this;
            this.markers[id].addListener('click', function () {
                var infowindow = new google.maps.InfoWindow({
                    content: this.infowin
                });
                infowindow.open(self.mapInstance, this);
            });
        }
    }

    cleanAllMarkers() {
        for (var m in this.markers) {
            this.markers[m].setMap(null);
            delete this.markers[m];
        }
    }

    cleanPolygons() {
        for (var m in this.poligons) {
            this.poligons[m].setMap(null);
            delete this.poligons[m];
        }
    }

    toggleCartoDbLayer(key) {

    }

    onOffCartoDbLayer(key, turn, data) {
        if (this.cartoDbLayers[key] !== undefined) {
            if (turn === true) {
                return this.cartoDbLayers[key].on();
            }
            return this.cartoDbLayers[key].off();
        } else {
            this.cartoDbLayers[key] = new CartoDbLayer(data.user_name, key, this.mapInstance, data);
        }
    }

    clean() {
        for (var i in this.poligons) {
            this.poligons[i].setMap(null);
            delete this.poligons[i];
        }

        for (var l in this.cartoDbLayers) {
            this.cartoDbLayers[l].off();
        }
    }
}